/**
 * Created by gpopescu on 18.08.2015.
 */
import $ = require('jquery');
import websiteData = require('diy/util/websiteData');
import VCardDataModel from './model';
let deeplinking: any = require('diy/util/deeplinking');

import l10n from 'diy/util/l10n';
import features = require('diy/util/features');

//import {mockData} from './mockData';

import * as React from 'react';
import ReactDOM = require('react-dom');
import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import diyLightTheme = require('../material-ui/diyLightTheme');

import FeedbackButton from '../feedback/FeedbackButton';
import { DiyFeedbackSubmit } from '../feedback/DiyFeedbackSubmit';
import {App as NotificationApp} from './../toolbar/notification/App';
import NotificationApi from './../toolbar/notificationNG/Api';
import {Notice as PrivacyNotice} from './../privacy/Notice';

interface VCardWebsiteConfig {
    resourcesUrl: string;
}

interface TriggerElement {
    element?: JQuery;
    openCallback?: Function;
    closeCallback?: Function;
    context?: string;
}

interface VCardEvent {
    name: string;
    type: string;
    data?: any;
}

export default class VCardEditor {
    protected editorWrapper: JQuery;
    protected editorContent: JQuery;

    protected openTrigger: TriggerElement;

    protected vCardClient: VCardApi;
    protected dataModel: VCardDataModel;

    protected toolbar: any;

    protected config = {
        resourcesUrl: websiteData.getData<VCardWebsiteConfig>('vcard').resourcesUrl
    };

    init() {
        this.createEditorWrapper();
        this.editorContent = this.editorWrapper.find('.vcard-editor-content');

        if (!features('notificationsNG')) {
            let notificationCenter = (diy.editor as any).notifications as any;
            let notificationCenterApi = notificationCenter.api as any;

            notificationCenterApi.ready(() => {
                let empNotification = notificationCenterApi.getNotificationsByType(
                    notificationCenter.Notifications.TYPE_EMP
                );

                if (empNotification.length === 1) {
                    empNotification[0].setVCardEditor(this);
                }
            });
        }
    }

    setToolbar(toolbar: any) {
        this.toolbar = toolbar;
    }

    createTriggerElement(trigger: TriggerElement) {
        trigger.element.click(() => this.open(trigger));
    }

    protected loadScript() {
        return Promise.resolve($.getScript(this.config.resourcesUrl + 'vcard.bundle.js'));
    }

    protected startVCardClient() {
        this.showLoader();

        this.initClient()
            .then((vCardClient) => {
                return this.dataModel.load();
            })
            .then((data) => {
                this.vCardClient.start(
                    this.editorContent[0],
                    data,
                    {
                        save: (vCardData: VCardClientData) => this.save(vCardData),
                        saveSemanticData: (data: VCardSemanticData) => this.saveSemanticData(data),
                        close: () => this.close(),
                        error: (reason: any) => {
                            this.showError('Failed to start vcard');
                        },
                        handleEvent: (event: VCardEvent) => {
                            switch (event.type) {
                                case "action":
                                    if (event.name === "editMyData") {
                                        this.vCardClient.save().then(() => {
                                            deeplinking.requestPath([
                                                {label: 'siteadmin', params: 'settings'},
                                                {label: 'SAC.Settings', params: 'personal-data'}
                                            ]);
                                        });
                                    }
                                break;
                                case "kpi":
                                    let context = (this.openTrigger && this.openTrigger.context)
                                        ? this.openTrigger.context : undefined;
                                    let instanceName = (event.data["instance"] !== undefined) ?
                                        "-" + event.data["instance"] : "";
                                    let visibility = (event.data["visibility"] !== undefined) ?
                                        "-" + ((event.data["visibility"]) ? "true" : "false") : "";
                                    this.trackLinkEvent(`${event.name}${instanceName}${visibility}`, context);
                                break;
                                default:
                                break;
                            }
                        },
                        onLoad: () => {
                             const vCardActionBar =  this.editorWrapper.find('.v-action-bar')[0];
                             const vcardFeedbackButton = $('<div id="vcard-feedback-button"></div>');
                             if (vCardActionBar && !$('#vcard-feedback-button')[0]) {
                                vcardFeedbackButton.css({
                                    position: 'absolute',
                                    bottom: 24,
                                    left: 24,
                                });
                                this.editorWrapper.append(vcardFeedbackButton);
                                ReactDOM.render(this.renderFeedbackButton(), vcardFeedbackButton[0]);
                            }
                            if (vCardActionBar && features('privacyNotice')) {
                                const vCardNoticeWrapper = $('<div id="vcard-privacy-policy-notice"></div>');
                                vCardNoticeWrapper.css({
                                    position: 'absolute',
                                    padding: '24px 16px',
                                    bottom: 0,
                                    left: 0,
                                    fontSize: '12px'
                                });
                                this.editorWrapper.find('.v-editor').append(vCardNoticeWrapper);
                                ReactDOM.render(this.renderPrivacyNotice(), vCardNoticeWrapper[0]);
                            }

                            this.hideLoader();

                            if (this.openTrigger && this.openTrigger.context) {
                                $(document).trigger('diy-editor-vcard-open', { source: this.openTrigger.context });
                            }

                            if (this.openTrigger && this.openTrigger.openCallback) {
                                this.openTrigger.openCallback();
                            }
                        }
                    },
                    this.getOptions()
                );
            })
            .catch((reason: any) => {
                console.error('Failed starting vcard:', reason);
                this.hideLoader();
                this.showError('Failed to start vcard');
            });
    }

    renderFeedbackButton() {
        return (
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <FeedbackButton
                    feedbackFeatureName=""
                    feedbackContext="vCard"
                    onFeedbackSubmit={DiyFeedbackSubmit}
                    useAlternativeColors={true}
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                    targetOrigin={{vertical: 'bottom',    horizontal: 'right'}}
                />
            </MuiThemeProvider>
        );
    }

    renderPrivacyNotice() {
        return (
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <PrivacyNotice />
            </MuiThemeProvider>
        );
    }

    protected getOptions() {
        return {
            locale: websiteData.getLanguageCode(),
            baseResourceUrl: this.config.resourcesUrl,
            baseUserUrl: function(uuid: string, format: string) {
                format = format || "preview";
                return '/rest/websites/' + websiteData.getId() + '/storage-files/' + uuid + '/' + format;
            }
        };
    }

    open(trigger?: TriggerElement) {
        $(top.document.body).trigger('MaintenanceModeOpened.BSA');
        if (trigger) {
            this.openTrigger = trigger;
        }

        this.startVCardClient();
        this.positionArrow();

        if (features('notificationsNG')) {
            NotificationApi.schedule(() => {
                NotificationApi.pause();
            });
        } else {
            NotificationApp.getNotificationApi().pause();
        }

        this.editorWrapper.css({
            'z-index': diy.editor.getNewTopZIndex(undefined, 'blockingModals')
        })
        .show();

        setTimeout(() => {
            this.editorWrapper
                .addClass('opened');
        }, 1); //add delay between show jquery function and addClass opened for transition to take effect
    }

    close() {
        return new Promise<void>((resolve, reject) => {
            this.editorWrapper
                .removeClass('opened')
                .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    (e) => {
                        if (this.vCardClient !== undefined) {
                            this.vCardClient.destroy();
                        }

                        this.editorWrapper
                            .off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
                            .hide();
                        $('#vcard-feedback-button').remove();
                        if (features('notificationsNG')) {
                            NotificationApi.schedule(() => {
                                NotificationApi.resume();
                            });
                        } else {
                            NotificationApp.getNotificationApi().resume();
                        }
                        resolve();
                });
        });
    }

    save(vCardData: VCardClientData) {
        this.editorContent.children().hide();
        $('#vcard-feedback-button').remove();
        this.showLoader();

        this.dataModel.save(vCardData)
            .then(() => {
                $(top.document.body).trigger('MaintenanceModeSaved.BSA');
                this.hideLoader();
                this.showAfterSaveConfirmation()
                    .then(() => {
                        this.close();
                        if (features('vcardFirstPublish')) {
                            features.disableFeature('vcardFirstPublish');
                            $(top.document.body).trigger('diy-maintenance-mode-vcard-publish');
                        }
                    });
            })
            .catch((reason: any) => {
                console.error('Could not save vcard', reason);
                this.hideLoader();
                this.showError('Could not save vcard');
            });
    }

    saveSemanticData(data: VCardSemanticData): Promise<SemanticDataResponseValues> {
        return this.dataModel.saveSemanticData(data);
    }

    protected initClient() {
        if (this.vCardClient !== undefined) {
            return Promise.resolve(this.vCardClient);
        }

        return this.loadScript()
                .then(() => {
                    this.vCardClient = vCard;
                    this.dataModel = new VCardDataModel(
                        this.vCardClient.getLatestVersion()
                    );
                    return this.vCardClient;
                });
    }

    /**
     * Displays a loading indicator.
     */
    protected showLoader() {
        let loaderEl = $('<div class="vcard-editor-loader"></div>').appendTo(
            this.editorWrapper.find('.vcard-editor-wrapper')
        );

        ReactDOM.render(
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <CircularProgress mode="indeterminate"/>
            </MuiThemeProvider>,
            loaderEl[0]
        );
    }

    /**
     * Hide a loading indicator.
     */
    protected hideLoader() {
        this.editorWrapper.find('.vcard-editor-loader').remove();
    }

    protected showError(errorMessage: string) {
        let closeLabel: string = l10n('toolbar.maintenance.offline.vcard.edit.close');

        console.warn(errorMessage);

        const messageEl = $(
            `<div class="vcard-editor-message-container">
                <div class="vcard-editor-error-box">
                    <div class="vcard-editor-error-box-section-heading">
                        <div class="vcard-editor-error-box-icon"></div>
                        <div class="vcard-editor-error-box-heading">
                            ` + l10n('toolbar.maintenance.offline.vcard.edit.error.heading') + `
                        </div>
                    </div>
                    <div class="vcard-editor-error-box-section-details">
                        <div class="vcard-editor-error-box-description">
                            ` + l10n('toolbar.maintenance.offline.vcard.edit.error.description') + `
                        </div>
                        <div class="vcard-editor-button"></div>
                    </div>
                </div>
            </div>`
        );

        this.editorWrapper.addClass('vcard-editor-message-showed');
        messageEl
            .appendTo(this.editorWrapper.find('.vcard-editor-wrapper'));

        ReactDOM.render(
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <RaisedButton onClick={() => {
                    this.close()
                        .then(() => {
                            messageEl.remove();
                            this.editorWrapper.removeClass('vcard-editor-message-showed');
                        });
                }} label={closeLabel} />
            </MuiThemeProvider>,
            messageEl.find('.vcard-editor-button')[0]
        );
    }

    protected createEditorWrapper() {
        this.editorWrapper = $(
            `<div id="vCardEditor" class="vcard-editor">
                <div class="vcard-editor-overlay"></div>
                <div class="vcard-editor-wrapper">
                    <div class="vcard-editor-anchor-arrow"></div>
                    <div class="vcard-editor-content"></div>
                    <div class="vcard-editor-loader" style="display:none"></div>
                </div>
            </div>`
        );

        this.editorWrapper
            .css('padding-top', this.toolbar.element.outerHeight())
            .hide()
            .appendTo('body')
            .wrap('<div class="diy-external"></div>');
    }

    protected positionArrow() {

        let websiteStatusIcon =
            $('.maintenanceModeContainer .icon');
        let arrowIcon =
            this.editorWrapper.find('.vcard-editor-anchor-arrow');

        arrowIcon.css({
            left: websiteStatusIcon.offset().left + (
                websiteStatusIcon.outerWidth() - arrowIcon.outerWidth()
            ) / 2
        });
    }

    protected showAfterSaveConfirmation(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            let confirmationElement = $(
                `<div class="save-confirmation">
                    <div class="disc">
                        <span class="checkmark"></span>
                    </div>
                    <span class="confirmation">
                        ${l10n('toolbar.maintenance.offline.vcard.edit.save.message')}
                    </span>
                </div>`
            );

            confirmationElement.appendTo(this.editorWrapper);

            setTimeout(() => {
                confirmationElement.addClass('done');
                setTimeout(() => {
                    confirmationElement
                        .fadeOut(1000, () => {
                            confirmationElement.remove();
                            resolve();
                        });
                }, 1500);
            }, 500);
        });
    }

    trackPageEvent () {
        $(top.document).trigger('diy-editor-generic-sectionAccessed', {
            'sectionCodeName': 'v-card'
        });
    };

    trackLinkEvent (section: string, context: string) {
        let pageNames: {[context: string]: string} = {
            'toolbar': "Toolbar maintenance flyout",
            'settings': "Settings Homepage",
            'onboardingGuide': "OnboardingGuide"
        };
        $(top.document).trigger('diy-editor-generic-linkInteraction', {
            'actionName': 'v-card.' + section,
            'pageName': pageNames[context]
        });
    };
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/vcard/integration.tsx
 **/